'use client'

import { useState } from 'react'
import { SmartHeader } from '@/widgets/smart-header'
import { Hero } from '@/widgets/hero'
import { HowItWorks } from '@/widgets/how-it-works'
import { Features } from '@/widgets/features'
import { Footer } from '@/widgets/footer'
import { FormSwitcher } from '@/widgets/form-switcher'
import { CompaniesCatalog } from '@/widgets/companies-catalog'
import { FAQ } from '@/widgets/faq'
import { SeoContent } from '@/widgets/seo-content'

type FormType = 'buy' | 'sell'

export default function HomePage() {
  const [activeForm, setActiveForm] = useState<FormType>('sell')

  return (
    <div className="relative flex min-h-screen flex-col">
      <SmartHeader />
      <main className="flex-1 pt-24">
        <Hero onFormTypeChange={setActiveForm} activeForm={activeForm} />
        <HowItWorks />
        <FormSwitcher activeForm={activeForm} />
        <div id="companies-catalog">
          <CompaniesCatalog />
        </div>
        <Features />
        <FAQ />
        <SeoContent />
      </main>
      <Footer />
    </div>
  )
}
